
export default function queries(state = { currentQuery: null, currentGlobal: null, currentQPs: null, modifiedGlobals: [], modifiedQPs: [] }, action) {
    switch (action.type) {
        case 'LOAD_PRESENTATIONS':
            return {
                ...state,
            }
        case 'SHOW_QUERY':
            return {
                ...state, currentQuery: action.payload
            }
        case 'CLEAR_QUERY':
            return {
                ...state, currentQuery: null
            }
        case 'SET_GLOBAL':
            return {
                ...state, currentGlobal: action.payload
            }
        case 'SET_QUICK_PICK':
            return {
                ...state, currentQPs: action.payload
            }
        case 'SAVE_CHANGED_QUICK_PICKS':
            return {
                ...state, modifiedQPs: action.payload
            }
        case 'SAVE_CHANGED_GLOBAL':
            let arr = state["modifiedGlobals"]
            let prev = arr.find(x => (x.id === action.payload.id))
            if (prev !== undefined) {
                let ind = arr.indexOf(prev)
                arr.splice(ind, 1)
            } 
            arr.push(action.payload)
            return {
                ...state, modifiedGlobals: arr
            }
        case 'LOGOUT_USER':
            return { ...state, currentQuery: null, currentGlobal: null, currentQPs: null, modifiedGlobals: [], modifiedQPs: [] }
        default:
            return state
    }
}